module.exports = __webpack_public_path__ + "static/renata-reis-lg-ec6add00da56f0a0477bdbca21c842a4.png";